<ng-container *transloco="let t;">

  <h2>{{ t('common.labels.log') }}</h2>

  <p-table *ngIf="logs.length > 0" [value]="logs" styleClass="p-datatable-sm" [paginator]="true" [rows]="100" stateStorage="local" [stateKey]="'logs-list-' + order?.id">
    <ng-template pTemplate="header">
      <tr>
        <th>{{ t('common.labels.time') }}</th>
        <th>{{ t('common.labels.event') }}</th>
        <th>{{ t('common.labels.info') }}</th>
        <th>{{ t('common.labels.user_recipient') }}</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-logentry>
      <tr>
        <td><p>{{ logentry.timestamp | amLocal | amDateFormat: 'DD.MM.YYYY - HH:mm:ss' }} {{ t('common.labels.oclock') }}</p></td>
        <td><p>{{ t('ac_log.changetypes.' + logentry.change) }}</p></td>
        <td>
          <p *ngIf="logentry.change !== 'mail'">{{ logentry.value }}</p>
          <p *ngIf="logentry.change === 'mail'">
            <a *ngIf="logentry.value !== null" class="pointer" (click)="onShowMailContent(logentry.message)">{{ logentry.value }}</a>
            <span *ngIf="logentry.value === null">{{ '' | anonymizedCandidate }}</span>
          </p>
        </td>
        <td>
          <p *ngIf="logentry.user !== null">{{ logentry.user }}</p>
          <p *ngIf="logentry.user === null">
            <span *ngIf="canSeeCandidates()">{{ t('common.labels.system') }}</span>
            <span *ngIf="!canSeeCandidates()">{{ '' | anonymizedCandidate }}</span>
          </p>
        </td>
      </tr>
    </ng-template>
  </p-table>

  <p-dialog [header]="t('common.labels.message')" [(visible)]="messageVisible" [style]="{width: '80vw'}" [draggable]="false" [modal]="true">
    <div class="maildata">
      <p>{{ t('common.labels.title') }}: <strong>{{ messageSelected?.title }}</strong></p>
      <p>{{ t('common.labels.recipient') }}: <strong>{{ messageSelected?.recipient }}</strong></p>
      <p>{{ t('common.labels.sended') }}:
        <strong *ngIf="messageSelected?.sended_at !== null">{{ messageSelected?.sended_at | amLocal | amDateFormat: 'DD.MM.YYYY - HH:mm' }} {{ t('common.labels.oclock') }}</strong>
        <ng-container *ngIf="messageSelected?.sended_at === null">
          <strong><span class="error">{{ t('sentmessages.error_on_sending') }}</span></strong> ({{ t('sentmessages.transmission_attempt') }}: {{messageSelected?.created_at | amLocal | amDateFormat: 'DD.MM.YYYY - HH:mm'}} {{ t('common.labels.oclock') }})
        </ng-container>
      </p>
    </div>
    <div class="mailcontent" [innerHtml]="messageSelected?.content"></div>
  </p-dialog>

</ng-container>
